import { apiClient } from "../../../api/client";
import * as ActionType from "./subCategory.type";
import { setToast } from "../../../util/toast";

export const getSubCategory = () => async (dispatch) => {
  const res = await apiClient.get("subCategory/getAllSubCategories");
  if (res.ok) {
    dispatch({ type: ActionType.GET_SUB_CATEGORY, payload: res.data?.subCategories });
  } else {
    console.log(res.message);
  }
};

export const createSubCategory = (data) => async (dispatch) => {
  const res = await apiClient.post("subCategory/insertSubCategory", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.CREATE_SUB_CATEGORY, payload: res.data?.subCategory });
    setToast("success", "Subcategory created successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const updateSubCategory = (data) => async (dispatch) => {
  const res = await apiClient.patch("subCategory/updateSubCategory", data);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.UPDATE_SUB_CATEGORY,
      payload: { data: res.data?.subCategory, id: data?.subCategoryId || data?._id },
    });
    setToast("success", "Subcategory updated successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const getCategoryWiseSubCategory = (categoryId) => async (dispatch) => {
  const res = await apiClient.get(
    `subCategory/categoryWiseSubCategory?categoryId=${categoryId}`
  );
  if (res.ok) {
    dispatch({
      type: ActionType.GET_CATEGORY_WISE_SUBCATEGORY,
      payload: res.data?.subCategories,
    });
  } else {
    console.log(res.message);
  }
};

export const deleteSubCategory = (id) => async (dispatch) => {
  const res = await apiClient.delete(
    `subCategory/deleteSubCategory?subCategoryId=${id}`
  );
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.DELETE_SUB_CATEGORY, payload: id });
    setToast("success", "Subcategory deleted successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};
